import { login, logout } from '../lib/auth';

export function Login() {
  return (
    <div className="card p-8 max-w-md mx-auto text-center animate-slide-up">
      <div className="mx-auto grid place-items-center h-14 w-14 rounded-2xl bg-gradient-to-br from-accent to-accent-deep text-white text-2xl font-bold shadow-glow mb-4">
        P
      </div>
      <h1 className="text-xl font-semibold mb-1">Welcome to peerbl</h1>
      <p className="text-sm text-mute mb-6">A community for thoughtful tech discussion.</p>
      <div className="space-y-2">
        <button onClick={() => login()} className="btn-primary w-full justify-center">
          Sign in with Cognito
        </button>
        <button onClick={() => logout()} className="btn-ghost w-full justify-center text-sm">
          Sign out
        </button>
      </div>
    </div>
  );
}
